import { AuthenticationResult, EventType, PublicClientApplication } from "@azure/msal-browser";
import { authConfig } from "./authConfig";

/**
 * MSAL should be instantiated outside of the component tree to prevent it from being re-instantiated on re-renders.
 * For more, visit: https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-react/docs/getting-started.md
 */
export const msalInstance = new PublicClientApplication(authConfig);

// Default to using the first account if no account is active on page load
if (!msalInstance?.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
  // Account selection logic is app dependent. Adjust as needed for different use cases.
  msalInstance.setActiveAccount(msalInstance?.getActiveAccount());
}

// Listen for sign-in event and set active account
msalInstance.addEventCallback(event => {
  if ((event.eventType === EventType.LOGIN_SUCCESS ) && (event.payload as AuthenticationResult)?.account) {
    const account = (event.payload as AuthenticationResult).account;
    msalInstance.setActiveAccount(account);
  }
});
